import { Injectable } from '@angular/core';

import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root'
})
export class JobUrgencyCalculatorService {
    calculateIfJobIsUrgent(startDate: string | null, startTime: string | null): boolean {
        if (!startDate || !startTime) {
            return false;
        }

        const now = DateTime.now();
        const selectedDate = startDate && startTime ? DateTime.fromISO(`${startDate}T${startTime}`) : '';

        if (!selectedDate) {
            return false;
        }

        const differenceInHours = selectedDate.diff(now, 'hours').toObject();
        const hours = differenceInHours.hours;

        return !!(hours && hours <= 24);
    }
}
